import React from 'react';

export default {
  ServicesPage: React.lazy(() => import('./HomePage/index')),
  AboutPage: React.lazy(() => import('./AboutPage/index')),
  PortfolioPage: React.lazy(() => import('./PortfolioPage/index')),
};
